export const sliderItems = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/9909123/pexels-photo-9909123.jpeg",
    title: "Winter SALE",
    
    description: " DON'T COMPROMISE ON STYLE! Flat 30% off for new Arrivals.",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "https://cdn.pixabay.com/photo/2021/11/20/14/36/man-6812001__340.png",
    title: "SUMMER SALE",
    description: " DON'T COMPROMISE ON STYLE! Flat 30% off for new Arrivals.",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "https://cdn.pixabay.com/photo/2018/02/08/11/54/male-3139289__340.jpg",
    title: "Popular SALE",
    description: " DON'T COMPROMISE ON STYLE! Flat 30% off for new Arrivals.",
    bg: "fbf0f4",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://cdn.pixabay.com/photo/2021/11/20/14/36/man-6812001__340.png",
    title: "shirt style",
    cat: "men",
  },
  {
    id: 2,
    img: "https://i.ibb.co/kgNBKbN/images-2022-04-25-T231522-990.jpg",
    title: "Kids love",
    cat: "kids",
  },
  {
    id: 3,
    img: require("./assets/images(30).jpeg"),
    title: "light jackets",
    cat: "women",
  },
];

export const popularProduct = [
  {
    id: 1,
    img: "https://cdn.pixabay.com/photo/2021/11/20/14/36/man-6812001__340.png",
    title: "Herman Shirt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut odio magni autem, rem unde culpa?",
    categories: ["men", "shirt"],
    size: ["XL", "XS", "S",],
    color: ["white"],
    price: 89,
    inStock: true,
    createdAt: "2022-04-30T10:38:17.284Z",
    updatedAt: "2022-04-30T10:38:17.284Z",
    __v: 0
  },
  {
    id: 2,
    img: "https://i.ibb.co/tK7JFLg/images-30.jpg",
    
    title: "Awesome Jacket",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut odio magni autem, rem unde culpa?",
    categories: ["men", "jacket"],
    size: ["S", "L", "M"],
    color: ["green"],
    price: 80,
    inStock: true,
    createdAt: "2022-04-30T10:38:17.284Z",
    updatedAt: "2022-04-30T10:38:17.284Z",
    __v: 0
  },
  {
    id: 3,
    img: "https://i.ibb.co/m9T19tW/download.jpg",
    title: "Blue T-Shirt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut odio magni autem, rem unde culpa?",
    categories: ["men", "tshirt"],
    size: ["XL", "XS", "S", "L", "M"],
    color: ["blue"],
    price: 79,
    inStock: true,
    createdAt: "2022-04-30T10:38:17.284Z",
    updatedAt: "2022-04-30T10:38:17.284Z",
    __v: 0
  },
  {
    id: 4,
    img: "https://i.ibb.co/4NGcY6z/images-28.jpg",
    title: "Red Love T-shirt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut odio magni autem, rem unde culpa?",
    categories: ["men", "tshirt"],
    size: ["XL", "L", "M"],
    color: ["red"],
    price: 99,
    inStock: true,
    createdAt: "2022-04-30T10:38:17.284Z",
    updatedAt: "2022-04-30T10:38:17.284Z",
    __v: 0
  },
  {
    id: 5,
    img:"https://i.ibb.co/YyCzws3/images-29.jpg",
    title: "Yellow t-shirt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut odio magni autem, rem unde culpa?",
    categories: ["men", "tshirt"],
    size: ["XL", "XS", "S", "L", "M"],
    color: ["yellow"],
    price: 109,
    inStock: true,
    createdAt: "2022-04-30T10:38:17.284Z",
    updatedAt: "2022-04-30T10:38:17.284Z",
    __v: 0
  },
  {
    id: 6,
    img: "https://i.ibb.co/rvyPXrD/images-32.jpg",
    title: "Herman greeny T-shirt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut odio magni autem, rem unde culpa?",
    categories: ["men", "tshirt"],
    size: ["XL", "L", "M"],
    color: [ "green"],
    price: 110,
    inStock: true,
    createdAt: "2022-04-30T10:38:17.284Z",
    updatedAt: "2022-04-30T10:38:17.284Z",
    __v: 0
  },
  {
    id: 7,
    img: "https://i.ibb.co/kgNBKbN/images-2022-04-25-T231522-990.jpg",
    title: "Kid T-shirt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut odio magni autem, rem unde culpa?",
    categories: ["kids", "tshirt"],
    size: [ "XS","S", "M"],
    color: ["green"],
    price: 69,
    inStock: true,
    createdAt: "2022-04-30T10:38:17.284Z",
    updatedAt: "2022-04-30T10:38:17.284Z",
    __v: 0
  },
  {
    id: 8,
    img: "https://i.ibb.co/jWNHNY0/pngtree-black-t-shirt-mockup-png-image-3610326.jpg",
    title: "Black T-Shirt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut odio magni autem, rem unde culpa?",
    categories: ["men", "tshirt"],
    size: ["XL", "XS", "S", "L", "M"],
    color: ["black"],
    price: 59,
    inStock: true,
    createdAt: "2022-04-30T10:38:17.284Z",
    updatedAt: "2022-04-30T10:38:17.284Z",
    __v: 0
  },
];
